import { createAction } from 'redux-actions';

import * as ACTION from './constants';

export const fetchPackages = createAction(ACTION.FETCH_PACKAGES.REQUEST, (params) => params);
export const exportPackageList = createAction(ACTION.EXPORT_PACKAGE_LIST.REQUEST, (params) => params);
